import { Box, Grid, Paper, Typography } from "@material-ui/core";
import { Assignment } from "@material-ui/icons";
import { green, purple } from "@mui/material/colors";
import { useSnackbar } from "notistack";
import { useRef, useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { useFetchEquipmentByIdMutation, useFetchGetEquipmentByNumberMutation } from "../api";
import { UserDataContext } from "../app/App";
import Layout from "../components/Layout/Layout";
import QRReaderDialog from "../components/custom/QRReaderDialog";

const useNavigateOnce = (history) => {
    const hasNavigated = useRef(false);

    return (equipment) => {
        if (!hasNavigated.current) {
            console.log("navigate !!");
            history.push(`/workshop/${equipment.id}`);
            hasNavigated.current = true;
        }
    };
};


function Workshop() {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const navigateOnce = useNavigateOnce(history);

    const { user } = useContext(UserDataContext);

    const {
        mutate: fetchEquipmentById,
        isLoading: isEquipmentByIdLoading,
        isError: isEquipmentByIdError,
    } = useFetchEquipmentByIdMutation({
        onSuccess: (equipment) => {
            navigateOnce(equipment);
        },
        onError: () => onFetchEquipmentError(),
    });

    const {
        mutate: fetchGetEquipmentByNumber,
        isLoading: isGetEquipmentByNumberLoading,
        isError: isGetEquipmentByNumberError,
    } = useFetchGetEquipmentByNumberMutation({
        onSuccess: (equipment) => {
            navigateOnce(equipment);
        },
        onError: () => onFetchEquipmentError(),
    });

    const onFetchEquipmentError = () => {
        enqueueSnackbar("Oops, that number didn't work. Try again?", {
            variant: "error",
            anchorOrigin: { vertical: "bottom", horizontal: "center" },
            autoHideDuration: 6000,
            preventDuplicate: true,
        });
    };

    const isEquipmentLoading = isEquipmentByIdLoading || isGetEquipmentByNumberLoading;
    const isEquipmentError = isEquipmentByIdError || isGetEquipmentByNumberError;

    return (
        <>
            <Layout color="#ff9602" title="Workshop" subtitle={user.name}>
                <Grid container direction="column" spacing={3}>
                    <Grid item style={{ width: "100%" }}>
                        <Paper
                            component={Box}
                            onClick={() => setIsDialogOpen(true)}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            py={10}
                            px={4}
                            square
                            elevation={5}
                            style={{ backgroundColor: purple[400] }}
                        >
                            <Typography variant="h5" style={{ color: "white" }}>
                                {`Scan QR Code`}
                            </Typography>
                            <QrCodeScannerIcon fontSize="large" style={{ color: purple[50] }} />
                        </Paper>
                    </Grid>

                    <Grid item style={{ width: "100%" }}>
                        <Link to="/workshop/mylist" style={{ textDecoration: "none" }}>
                            <Paper
                                component={Box}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                py={10}
                                px={4}
                                square
                                elevation={5}
                                style={{ backgroundColor: green[400], cursor: "pointer" }}
                            >
                                <Typography variant="h5" style={{ color: "white" }}>
                                    My List
                                </Typography>
                                <Assignment fontSize="large" style={{ color: green[50] }} />
                            </Paper>
                        </Link>
                    </Grid>
                </Grid>
            </Layout>

            <QRReaderDialog
                open={isDialogOpen}
                isLoading={isEquipmentLoading}
                isError={isEquipmentError}
                onClose={() => setIsDialogOpen(false)}
                onQRCodeScanSuccess={fetchEquipmentById}
                onManualSuccess={fetchGetEquipmentByNumber}
            />
        </>
    );
}

export default Workshop;
